export const LANDING_HEADLINE = 'Turn your league streams into a media hub.';

export const LANDING_SUBHEADLINE =
  'League Stream Center is the verified league stream and VOD archive hub for your community. Commissioners review and publish the final archive. Members watch published games—not a generic Twitch directory.';

export const LANDING_HERO_PRIVACY =
  'We process Twitch and YouTube (youtube.readonly) data only to organize your league archive. Read our';

export const LANDING_HERO_PRIVACY_LINK = 'Privacy Policy';

export const LANDING_CTA_LOGGED_OUT = 'Sign in with Twitch';
export const LANDING_CTA_LOGGED_IN = 'Open Stream Center';
export const LANDING_CTA_SECONDARY = 'See how it works';
export const LANDING_CTA_VIEW_PRICING = 'View pricing';
export const LANDING_CTA_START_SETUP = 'Start league setup';

export const COMING_SOON_EYEBROW = 'League Stream Center';
export const COMING_SOON_HEADLINE = 'COMING SOON';
export const COMING_SOON_WAITLIST_HEADING = 'Join the Waitlist';
export const COMING_SOON_WAITLIST_DETAIL =
  'Leave your name and email. We will write you when Stream Center opens.';
export const COMING_SOON_SUCCESS =
  "You're on the list — we'll email you when LSC opens";
export const COMING_SOON_STUDIO_CTA = 'Go to Scoutlytics Studio';
export const COMING_SOON_SUBMIT = 'Join the Waitlist';

export const LANDING_MEMBER_LANE_TITLE = 'Join a league for free';
export const LANDING_MEMBER_LANE_DETAIL =
  'Sign in with Twitch and enter an invite code from your commissioner to join immediately.';
export const LANDING_MEMBER_LANE_CTA = 'Enter invite code';
export const LANDING_MEMBER_LANE_SIGN_IN = 'Sign in to join';

export const LANDING_COMMISSIONER_LANE_TITLE = 'Start a league as commissioner';
export const LANDING_COMMISSIONER_LANE_DETAIL =
  'Creating a league requires an active commissioner subscription. View plans to get started.';
export const LANDING_COMMISSIONER_LANE_CTA = 'View commissioner plans';
export const LANDING_COMMISSIONER_LANE_CREATE = 'Create league';

export const LANDING_PRICING_SECTION_ID = 'lsc-landing-pricing';
export const LANDING_PRICING_HEADLINE = 'Subscription pricing';
export const LANDING_PRICING_SUMMARY =
  'League Stream Center: $19.99/month or $199.99/year — one league subscription.';
export const LANDING_PRICING_DETAIL =
  'Organize Twitch VODs into a league-only archive hub. Commissioners review before publishing. Twitch VOD expiration still applies.';

export const LANDING_PRODUCT_MOCK_ID = 'lsc-landing-product-mock';
export const LANDING_HOW_IT_WORKS_ID = 'lsc-landing-how-it-works';

export const LANDING_SECTION_PRODUCT_MOCK = 'Your League Media Hub';
export const LANDING_SECTION_VALUE_PILLARS = 'Built for League Media, Not Admin Clutter';
export const LANDING_SECTION_HOW_IT_WORKS = 'How It Works';
export const LANDING_SECTION_COMPARISON = 'Why Not Just Twitch or Discord?';
export const LANDING_SECTION_BENEFITS = 'For Commissioners and Members';

export const LANDING_VALUE_PILLARS = [
  {
    title: 'Live Games First',
    description: 'League streams surface on your hub when members are live and setup is complete.',
  },
  {
    title: 'Replay Library',
    description: 'Published games become searchable league archives.',
  },
  {
    title: 'GameDay Matchups',
    description: 'Upcoming games get clean VS cards with team visuals.',
  },
  {
    title: 'Commissioner Control',
    description: 'Review and publish without cluttering the member experience.',
  },
  {
    title: 'Built for League Culture',
    description: 'Watch, rewatch, and follow the story of the season.',
  },
] as const;

export const LANDING_HOW_IT_WORKS_STEPS = [
  {
    step: 1,
    title: 'Connect Your League',
    description: 'Bring your league workspace online.',
  },
  {
    step: 2,
    title: 'Match Streams to Games',
    description: 'Link broadcasts to official matchups.',
  },
  {
    step: 3,
    title: 'Publish League Replays',
    description: 'Commissioners approve and publish league-ready archives.',
  },
  {
    step: 4,
    title: 'Build Your League Media Hub',
    description: 'Give members a home for live games and replays.',
  },
] as const;

export const LANDING_COMPARISON_ROWS = [
  {
    platform: 'Twitch',
    limitation: 'Stores streams temporarily, but does not know your league schedule.',
    lscAdds: 'Game media tied to official matchups after schedule and member setup.',
    featured: false,
  },
  {
    platform: 'Discord',
    limitation: 'Hosts conversation, but does not organize verified game media.',
    lscAdds: 'Searchable archives by week, team, and broadcaster.',
    featured: false,
  },
  {
    platform: 'League Stream Center',
    limitation: null,
    lscAdds:
      'Connects streams, schedule, replays, and commissioner review into one league media layer.',
    featured: true,
  },
] as const;

export const LANDING_COMMISSIONER_BENEFITS = [
  'Less VOD hunting',
  'Cleaner publishing',
  'Polished league hub',
  'Tools stay in the cockpit',
] as const;

export const LANDING_MEMBER_BENEFITS = [
  'Watch live games',
  'Catch latest replays',
  'Find games by week, team, or broadcaster',
  'See upcoming matchups',
] as const;

export const LANDING_COCKPIT_CAPTION =
  'Commissioner tools stay in the cockpit, not the member view.';
